module.exports = __webpack_public_path__ + "static/img/government_bg_top.12d430e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/government_bg_top.png
// module id = +xkE
// module chunks = 1